/* eslint-disable no-unused-vars */
/*
 * @Author: 王丛
 * @Date: 2021-12-31 15:49:47
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-05-12 16:28:50
 * @Description: file content
 */
import Vue from 'vue';

import StaticMonitor from '@cy/staticMonitor';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Popup, Picker, DatetimePicker, Loading } from 'vant';
import * as Sentry from '@sentry/vue';
import App from './App.vue';
import router from './router';
import store from './store';
import '@/assets/styles/index.scss';
import './cube-ui/cube-ui.js';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'vant/lib/index.css';

Vue.use(Popup);
Vue.use(Picker);
Vue.use(DatetimePicker);
Vue.use(Loading);
Swiper.use([Navigation, Pagination, Autoplay]);
Vue.config.productionTip = false;
const isProd = process.env.NODE_ENV === 'production';
// 只针对生产环境使用
if (isProd) {
  Sentry.init({
    Vue,
    dsn: 'https://cfcd84df646d4ba18803156aef095338@sentry.chunyutianxia.com/13',
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration(),
    ],

    tracesSampleRate: 0.2,
    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost'],
    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
  const opt = {
    project_name: 'vue-m-comprehensive', // 项目名称
    desc: '', // 用来替代接口的 description 字段，默认为：前端监控-静态资源加载错误上报
  };

  // eslint-disable-next-line no-new
  new StaticMonitor(opt);
}
if (process.env.NODE_ENV !== 'production') {
  import('vconsole').then(VConsole => {
    // eslint-disable-next-line
    new VConsole.default();
  });
}

Vue.use(VueAwesomeSwiper);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
